import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import {Core2Config} from '../../shared/core2Config';
import { BankReconContainerModel } from '../../../../../../models/aggregates/erp/index';
import { ApiVisa,PagingResponseModel } from '../../shared';
import { BankReconCashbookBalanceOutputDtoModel } from '../../../../../../models/aggregates/erp/bankrecon/bank-recon-cashbook-balance-output-dto.model';
import {BankReconEditCashbookBalancesOutputDto} from '../../../../../../models/aggregates/erp/bankrecon/bank-recon-edit-cashbook-balances-output-dto.model';
import { CashBookEditOpenBalancesInputDto } from '../../../../../../models/aggregates/cashbook/cashbook-edit-open-balances-input.model.dto';

@Injectable({
    providedIn: 'root'
})
export class BankReconService extends BaseApiPublicLoginTemplateService<BankReconContainerModel, BankReconContainerModel, BankReconContainerModel> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-reconciliation';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/bank-reconciliation';
        this.httpClient = http;
    }

    public getReportOne(bankReconGuid, apiVisa: ApiVisa) {
            let url = apiVisa.api_domain_url + this.endpoint_path + '/report-one';
            return this.httpClient.post(
                url,
                { bank_recon_guid: bankReconGuid },
                this.getHttpHeader(apiVisa)
            );
    }


    public getReportThree(bankReconGuid, apiVisa: ApiVisa) {
            let url = apiVisa.api_domain_url + this.endpoint_path + '/report-three/backoffice-ep';
            return this.httpClient.post(
                url,
                { bank_recon_guid: bankReconGuid },
                this.getHttpHeader(apiVisa)
            );
    }


    public getBankReconCreateBalance(cashbookGuid: string, apiVisa: ApiVisa) {
        const url = `${apiVisa.api_domain_url}${this.endpoint_path}/create-balances/backoffice-ep/${cashbookGuid}`;
        return this.httpClient.get<PagingResponseModel<BankReconCashbookBalanceOutputDtoModel>>(
              url,
              this.getHttpHeader(apiVisa)
            );
    }

    public getBankReconEditBalance(inputDto:CashBookEditOpenBalancesInputDto , apiVisa: ApiVisa) {
        const url = `${apiVisa.api_domain_url}${this.endpoint_path}/create-balances/cashbook-edit/backoffice-ep`;
        return this.httpClient.post<PagingResponseModel<BankReconEditCashbookBalancesOutputDto>>(
              url,
              inputDto,
              this.getHttpHeader(apiVisa)
            );
    }
    
}

